module.exports = __webpack_public_path__ + "img/4_Da_hoan_thanh.06e64f93.png";